import { render, staticRenderFns } from "./headerNotice.vue?vue&type=template&id=0ce6e232&scoped=true&"
import script from "./headerNotice.vue?vue&type=script&lang=js&"
export * from "./headerNotice.vue?vue&type=script&lang=js&"
import style0 from "./headerNotice.vue?vue&type=style&index=0&id=0ce6e232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6e232",
  null
  
)

export default component.exports